<div class="featured-container">
  <h1 class="featured-text">Featured</h1>
  <div class="featured-scroll-container" fxLayout="row" fxLayoutAlign="start">
    <app-featured-card
      class="card"
      *ngFor="let feature of features"
     [content]="feature">
    </app-featured-card>
    <div class="shadow"></div>
  </div>
</div>
